import { useState } from 'react';
import { ChromeStar } from './ChromeStar';

export function Placeholder({ label, className = '', dark = false }) {
  return (
    <div
      className={`sheen relative flex items-center justify-center overflow-hidden border ${
        dark ? 'border-white/15 bg-[#111111]' : 'border-black/10 bg-concrete'
      } ${className}`}
    >
      <div className="relative z-10 flex flex-col items-center gap-3 px-6 text-center">
        <ChromeStar className="h-4 w-4 opacity-70" />
        <span
          className={`font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.28em] leading-relaxed ${
            dark ? 'text-neutral-500' : 'text-neutral-500'
          }`}
        >
          {label}
        </span>
      </div>
    </div>
  );
}

export function SmartImg({ src, alt = '', label, className = '', eager = false }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return <Placeholder label={label || alt || 'IMAGE FORTHCOMING'} className={className} />;
  }
  return (
    <img
      src={src}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      onError={() => setFailed(true)}
      className={className}
      draggable="false"
    />
  );
}
